import { defineComponent as _defineComponent } from 'vue'
import { ref, useAttrs, computed } from 'vue-demi';
import ScanGift from './scan-gift/scan-gift.vue';
import ScanGiftC2C from './c2c/index.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const attrs = useAttrs();
const isShowScanGiftC2C = ref(attrs.isSupportC2C);

const componentMap = { ScanGiftC2C, ScanGift };
const componentName = computed(() => (isShowScanGiftC2C.value ? componentMap.ScanGiftC2C : componentMap.ScanGift));

function onHideC2C() {
  isShowScanGiftC2C.value = false;
}

return { __sfc: true,attrs, isShowScanGiftC2C, componentMap, componentName, onHideC2C }
}

})